<template>
  <div
    class="login_remis_customer row"
    :class="showConfirmationLoader ? 'loading_remis_conf' : null"
  >
    <div
      class="col-md-6 login_remis_first_section"
      :class="showConfirmationLoader ? 'add_padding_conf' : null"
    >
      <div v-if="showConfirmationLoader">
        <img src="https://epump.com.ng/images/logo2.svg" class="company_logo" />

        <p class="mt-3 text-center login_remis_text email_remis_confirm">
          {{ $t("text.accountConfirmation.emailConfirmation") }}
        </p>
        <p class="text-center confirmation_remis_text">
          {{ $t("text.accountConfirmation.pleaseWait") }} <br />
          {{ $t("text.accountConfirmation.weConfirm") }}
        </p>
        <p class="text-center confirmation_remis_text">
          {{ $t("text.accountConfirmation.proceed") }} <br />
          {{ $t("text.accountConfirmation.afterSuccessfulConfirmation") }}
        </p>
      </div>

      <div v-if="confirmed">
        <div class="mt-5 text-center confirmed_image">
          <img src="@/assets/img/Path 517.png" width="200px" />
        </div>

        <p
          class="mt-5 text-center confirmation_remis_text_header confirmation_remis_text"
        >
          {{ $t("text.accountConfirmation.accountConfirmed") }}
        </p>
        <p class="text-center confirmation_remis_text">
          {{ $t("text.accountConfirmation.thankYou") }}<br />
          {{ $t("text.accountConfirmation.login") }}
        </p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="pt-4 login_remis_section" v-if="!showConfirmationLoader">
        <h4>{{ $t("text.accountConfirmation.sign") }}</h4>
        <form>
          <div class="remis_login_field">
            <label>{{ $t("text.accountConfirmation.emailAddress") }}</label>
            <input
              v-model="email"
              @blur="checkEmail"
              :class="!emailFormatGood ? 'red_back' : null"
            />
          </div>
          <div class="remis_login_field">
            <label>Password</label>
            <input type="password" v-model="password" />
          </div>
          <button
            @click="login"
            :disabled="disableButton"
            :class="disableButton ? 'login_loading' : null"
          >
            <p v-if="!disableButton">
              {{ $t("text.accountConfirmation.sign") }}
            </p>
            <div class="loader_spinner">
              <pulse-loader
                :color="color"
                size="15px"
                v-if="disableButton"
              ></pulse-loader>
            </div>
          </button>
          <p class="text-center">
            {{ $t("text.accountConfirmation.noAccount") }}
            <router-link :to="{ name: 'signup' }" class="remis_sign_up_link">{{
              $t("text.accountConfirmation.signUp")
            }}</router-link>
          </p>
        </form>
      </div>
      <div
        class="loader_spinner confirmation_loading_back"
        v-if="showConfirmationLoader"
      >
        <pulse-loader :color="color" size="100px"></pulse-loader>
      </div>
    </div>
  </div>
</template>

<script>
import jwt_decode from "jwt-decode";
import configObject from "@/config";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";

export default {
  title: "Confirm email - Epump Portal",
  components: {
    PulseLoader,
    ClipLoader,
  },
  data() {
    return {
      color: this.$store.getters.getDatePickerColor,
      email: "",
      password: "",
      disableButton: false,
      emailFormatGood: true,
      showConfirmationLoader: true,
      confirmed: false,
    };
  },
  mounted() {
    this.showConfirmationLoader = true;

    const data = {
      userId: this.$route.query.userId,
      code: this.$route.query.code,
    };

    this.axios
      .post(`${configObject.apiBaseUrl}/Account/confirm`, data)
      .then((response) => {
        this.confirmed = true;
        this.showConfirmationLoader = false;
        this.$toast.success(
          this.$t("text.accountConfirmation.thanksForConfirming")
        );
      })
      .catch((error) => {
        this.confirmed = false;
        this.showConfirmationLoader = false;
        this.$toast.open({
          message: error.response.data.message,
          type: "error",
          duration: 5000,
        });
      });
  },
  methods: {
    checkEmail() {
      if (!this.email) {
        this.$toast.open({
          message: this.$t("text.errors.emailMissing"),
          type: "error",
          duration: 3500,
        });
        this.emailFormatGood = false;
        return;
      }
      if (!this.validEmail(this.email)) {
        this.$toast.open({
          message: this.$t("text.errors.invalidEmail"),
          type: "error",
          duration: 5000,
        });
        this.emailFormatGood = false;
        return;
      }
      this.emailFormatGood = true;
    },
    validEmail(email) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return true;
      }
      return false;
    },
    login($event) {
      $event.preventDefault();

      this.checkEmail();
      if (!this.emailFormatGood) return;
      if (!this.password) {
        this.$toast.open({
          message: this.$t("text.errors.passwordMissing"),
          type: "error",
          duration: 2000,
        });
        return;
      }

      this.disableButton = true;
      let data = {
        userName: this.email,
        password: this.password,
      };
      this.axios
        .post(`${configObject.apiBaseUrl}/Account/login`, data)
        .then((response) => {
          let userDetails = response.data;
          userDetails.roles = userDetails.role.split(",");
          this.disableButton = false;

          if (
            userDetails.roles &&
            !userDetails.roles.includes("Company") &&
            !userDetails.roles.includes("Branch") &&
            !userDetails.roles.includes("POS Owner") &&
            !userDetails.roles.includes("Customer") &&
            !userDetails.roles.includes("Account Manager") &&
            !userDetails.roles.includes("POS Bank") &&
            !userDetails.roles.includes("SupportAdmin")
          ) {
            this.$t("text.errors.noAccess");
            return;
          }

          this.$store.commit("setUserInfo", userDetails);
          var decoded = jwt_decode(userDetails.token);
          const exp = decoded.exp * 1000;
          localStorage.setItem("jwtExpiry", exp);
          localStorage.setItem("color", "#370f70");
          this.$store.commit("setDatePickerColor", "#370f70");

          const viewOnly = userDetails.roles.includes("View Only");
          this.$store.commit("setViewOnly", viewOnly);
          localStorage.setItem("userDetails", JSON.stringify(userDetails));
          this.$toast.success(this.$t("text.login.loginSuccessful"));
          if (userDetails.roles.includes("Company")) {
            this.$router.push({ name: "companyDashboard" });
          } else if (userDetails.roles.includes("Branch")) {
            this.$router.push({ name: "branchDashboard" });
          } else if (userDetails.roles.includes("IndustryManager")) {
            this.$router.push({ name: "IndustrialBranchDashboard" });
          } else if (
            userDetails.role === null ||
            userDetails.roles.includes("Customer") ||
            userDetails.roles.includes("Account Manager")
          ) {
            this.$store.commit("setUserRole", userDetails.role);
            this.$router.push({ name: "userDashboard" });
          }
        })
        .catch((error) => {
          this.disableButton = false;
          this.$toast.open({
            message:
              error.response.data.message == "ForcePasswordChange"
                ? "You need to reset your password to continue using the portal"
                : null,
            type: "error",
            duration: 2000,
          });
          if (error.response.data.message == "ForcePasswordChange") {
            this.$router.push({ path: "/Account/reset-password-request" });
          }
        });
    },
  },
};
</script>

<style></style>
